import Image from 'next/image';

import * as Slider from '@radix-ui/react-slider';
import { cn } from '@/utils/cn';

interface LevelProgressProps {
  totalPoints: number;
  remainingPoints: number;
  maxPoints: number;
}

const LevelProgress: React.FC<LevelProgressProps> = ({ totalPoints, remainingPoints, maxPoints }: LevelProgressProps) => {
  const newLevelUnlocked = remainingPoints <= 0;

  return (
    <div className='flex flex-col gap-1 w-full p-6 rounded-b-2xl border-t border-border-primary bg-surface-primary'>
      <div className='flex items-center justify-end gap-1'>
        <span className='text-2xl font-semibold text-text-primary'>
          {totalPoints} / {maxPoints}
        </span>
        <Image src='/assets/quanta/quanta-points.png' alt='Quanta Points' width={30} height={30} />
      </div>
      <Slider.Root className='flex items-center w-full select-none' value={[totalPoints]} max={maxPoints} step={1} disabled>
        <Slider.Track className='relative h-[18px] grow rounded-full bg-surface-secondary'>
          <Slider.Range className={cn('absolute h-full rounded-l-full bg-text-primary', totalPoints >= maxPoints && 'rounded-r-full')} />
        </Slider.Track>
      </Slider.Root>
      <span className='text-lg text-text-secondary text-end'>
        {newLevelUnlocked ? 'New level unlocked' : `${remainingPoints} Quanta needed to level up`}
      </span>
    </div>
  );
};

export default LevelProgress;
